import Component from './applicant_duplicate_entries.vue'
export default Component
